import { useRef } from "react";

/** Remembers the last-viewed channel per space (persisted in localStorage) so returning to a space restores where you left off. */
export function useLastChannelBySpace() {
  // Last-viewed channel per space (persisted) so returning to a space restores
  // where you left off; falls back to the space home channel on first visit.
  // Stale entries (deleted or access-revoked channels) self-heal via the
  // sidebarChannels auto-select effect, same as a stale homeChannelId.
  const lastChannelBySpaceRef = useRef<Record<string, string> | null>(null);
  function getLastChannelBySpace(): Record<string, string> {
    if (!lastChannelBySpaceRef.current) {
      try {
        const s = localStorage.getItem('lastChannelBySpace');
        lastChannelBySpaceRef.current = s ? JSON.parse(s) : {};
      } catch { lastChannelBySpaceRef.current = {}; }
    }
    return lastChannelBySpaceRef.current!;
  }
  function rememberLastChannel(spaceId: string, channelId: string) {
    if (!spaceId || !channelId || String(spaceId).startsWith('dm_')) return;
    const map = getLastChannelBySpace();
    if (map[spaceId] === channelId) return;
    map[spaceId] = channelId;
    try { localStorage.setItem('lastChannelBySpace', JSON.stringify(map)); } catch { /* noop */ }
  }
  return { getLastChannelBySpace, rememberLastChannel };
}
